const TableHead = ({ children }) => {
    return  (
        <thead className="main-list__table-head">
            {children}
        </thead>
    );
};

export default TableHead;
